import React from 'react'
import { Provider, observer } from 'mobx-react'
import { Switch, Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'

import storesToProvide from './storesManager'
import appRoutes from './appRoutes'
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router'

const browserHistory = createBrowserHistory()
const routingStore = new RouterStore()

const history = syncHistoryWithStore(browserHistory, routingStore)

const storesProps = { ...storesToProvide, routing: routingStore }

const App = (
  (storesToProvide) => () =>
    (
      <Provider {...storesProps}>
        <Router history={history}>
          <Switch>{appRoutes}</Switch>
        </Router>
      </Provider>
    )
)(storesToProvide)

export default observer(App)
